import { getLogger } from '@sas/nova-core/logging';
import { Folder, UnknownNode } from '@sas/react-svg';
// Content component logger components
// The idea is to divy up areas of the content code one might want to turn on logging for.
// Logging turned on by appending '?nova-log=<component>:debug' to your URL.
// 'debug' can be the desired Nova logging level.
// NOTE: The components themselves will just use their component name for all logging within their
// subfolders, like with other Nova components.
// Everything under content/services
export const CONTENT_SERVICES_LOGGER_COMPONENT = 'contentServices';

// Everything under content/services/__mocks__
export const CONTENT_MOCKS_LOGGER_COMPONENT = 'contentMocks';

// Everything under content/actions
export const CONTENT_ACTIONS_LOGGER_COMPONENT = 'contentActions';

// Everything under content/hooks
export const CONTENT_HOOKS_LOGGER_COMPONENT = 'contentHooks';

// Everything under content/providers
export const CONTENT_PROVIDERS_LOGGER_COMPONENT = 'contentProviders';

// Everything under content/utils
export const CONTENT_UTILS_LOGGER_COMPONENT = 'contentUtils';
const logger = getLogger(CONTENT_UTILS_LOGGER_COMPONENT);
const blockBreak = '//////////////////////////////';
const lineBreak = '------------------------------';
const formatLogDetails = details => {
  const lines = [];
  for (const detail of details) {
    if (typeof detail === 'string') {
      lines.push(detail);
    } else {
      const [label, value] = detail;
      if (typeof value === 'string' || typeof value === 'number') {
        lines.push(`${label}: ${value}`);
      } else if (value instanceof Error) {
        lines.push(`${label}:\n${value.name}: ${value.message}`);
      } else {
        lines.push(`${label}:\n${JSON.stringify(value, null, 2)}`);
      }
    }
  }
  const result = `${blockBreak}\n${lines.join(`\n${lineBreak}\n`)}\n${blockBreak}`;
  return result;
};
const formatLogDetailsWithHeading = ([heading, ...details]) => {
  return `${heading}\n${formatLogDetails(details)}`;
};

/**
 * Create a formatter that can be used to generate detailed log messages.
 * Resulting log message will look something like:
 * (submodule) Descriptive heading
 * ///////////////////////////
 * Text detail: text value.
 * --------------------------
 * Number detail: 154
 * --------------------------
 * Object details:
 * {
 *   foo: 'bar'
 * }
 * --------------------------
 * Error detail:
 * ErrorName: The error message
 * ///////////////////////////
 * @param submodule For consistency, if the logger "component" refers to a particular folder,
 * then "submodule" should be the relative path to the file where the message is logged.
 * @returns Formatted text
 */
export const createLogMsgFormatter = submodule => {
  return ([heading, ...details]) => formatLogDetailsWithHeading([`(${submodule}) ${heading}`, ...details]);
};
export const getItemsWithIcons = (items, resolveIcon) => {
  const itemsOrEmpty = items ?? [];
  return itemsOrEmpty.map(item => {
    return {
      item,
      icon: getItemIcon(item, resolveIcon)
    };
  });
};
export const getItemIcon = (item, resolveIcon) => {
  const iconName = item.resource?.imagery?.iconKey;
  const icon = resolveIcon?.(iconName);
  const fallbackIcon = item.resource?.type?.isFolder ? Folder : UnknownNode;
  if (!icon) {
    // This likely means an incorrect iconKey was passed. We don't really want this to break
    // anything, so instead log a warning and use a basic folder/unknown fallback
    logger.warn(`Could not retrieve icon with key "${iconName}". Falling back to ${fallbackIcon.name}.`);
  }
  return icon ?? fallbackIcon;
};
//# sourceMappingURL=common.js.map